/* eslint-disable */
require('script-loader!file-saver');
require('./Blob.js');
require('script-loader!xlsx/dist/xlsx.core.min');
import XLSX from 'xlsx-style'
import { message } from 'ant-design-vue'
function generateArray(table) {
    var out = [];
    var rows = table.querySelectorAll('tr');
    var ranges = [];
    for (var R = 0; R < rows.length; ++R) {
        var outRow = [];
        var row = rows[R];
        var columns = row.querySelectorAll('td');
        for (var C = 0; C < columns.length; ++C) {
            var cell = columns[C];
            var colspan = cell.getAttribute('colspan');
            var rowspan = cell.getAttribute('rowspan');
            var cellValue = cell.innerText;
            if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

            //Skip ranges
            ranges.forEach(function (range) {
                if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                    for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
                }
            });

            //Handle Row Span
            if (rowspan || colspan) {
                rowspan = rowspan || 1;
                colspan = colspan || 1;
                ranges.push({ s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 } });
            }
            ;

            //Handle Value
            outRow.push(cellValue !== "" ? cellValue : null);

            //Handle Colspan
            if (colspan) for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
        }
        out.push(outRow);
    }
    return [out, ranges];
};

function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
    var ws = {};
    var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            var cell = { v: data[R][C] };
            if (cell.v == null) continue;
            var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

            if (typeof cell.v === 'number') cell.t = 'n';
            else if (typeof cell.v === 'boolean') cell.t = 'b';
            else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';

            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
}

function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export function export_table_to_excel(id) {
    var theTable = document.getElementById(id);
    console.log('a')
    var oo = generateArray(theTable);
    var ranges = oo[1];

    /* original data */
    var data = oo[0];
    var ws_name = "SheetJS";
    console.log(data);

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);

    /* add ranges to worksheet */
    // ws['!cols'] = ['apple', 'banan'];
    ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });

    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "test.xlsx")
}

function formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => (v[j] || v[j] === 0 ) ? v[j] : ''))
}

export function exportJsonToExcelWithTitle(th, th_2, filterVal, jsonData, defaultTitle) {

  /* original data */

  var data = formatJson(filterVal, jsonData);
  data.unshift(th);
  data.unshift(th_2);
  var ws_name = defaultTitle ? defaultTitle : "SheetJS";

  var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);
  // console.log('data:', data)
  /*设置worksheet每列的最大宽度*/
  data.shift();
  const colWidth = data.map(row => row.map(val => {
    /*先判断是否为null/undefined*/
    if (val == null) {
      return {
        'wch': 10
      };
    }
    /*再判断是否为中文*/
    else if (val.toString().charCodeAt(0) > 255) {
      return {
        'wch': val.toString().length * 2
      };
    } else {
      return {
        'wch': val.toString().length
      };
    }
  }))

  /*以第一行为初始值*/
  let result = colWidth[0];
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (result[j]['wch'] < colWidth[i][j]['wch']) {
        result[j]['wch'] = colWidth[i][j]['wch'];
      }
    }
  }
  ws['!cols'] = result;

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var dataInfo = wb.Sheets[wb.SheetNames[0]];
  const borderAll = {  //单元格外侧框线
    top: {
      style: 'thin'
    },
    bottom: {
      style: 'thin'
    },
    left: {
      style: 'thin'
    },
    right: {
      style: 'thin'
    }
  };
  const headerStyle = {
    font: {
      name: '宋体',
      sz: 12,
      color: {rgb: "000000"},
      bold: true,
      italic: false,
      underline: false
    },
    alignment: {
      horizontal: "center",
      vertical: "center"
    },
  }
  //给所有单元格加上边框
  for (var i in dataInfo) {
    if (i == '!ref' || i == '!merges' || i == '!cols' || i == 'A1') {

    } else {
      if (/^([A-Z]+)1$/.test(i)) {
        dataInfo[i + ''].s = {
          border: borderAll,
          font: headerStyle.font,
          alignment: headerStyle.alignment
        }
      } else {
        dataInfo[i + ''].s = {
          border: borderAll
        }
      }
    }
  }

  var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
  var title = defaultTitle || '列表'
  saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xlsx")
}

export function exportJsonToExcel(th, filterVal, jsonData, defaultTitle) {
    message.info('文件开始下载')
    /* original data */

    var data = formatJson(filterVal, jsonData);
    data.unshift(th);
    var ws_name = defaultTitle ? defaultTitle : "SheetJS";

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);
    // console.log('data:', data)
    /*设置worksheet每列的最大宽度*/
    const colWidth = data.map(row => row.map(val => {
        /*先判断是否为null/undefined*/
        if (val == null) {
            return {
                'wch': 10
            };
        }
        /*再判断是否为中文*/
        else if (val.toString().charCodeAt(0) > 255) {
            return {
                'wch': val.toString().length * 2
            };
        } else {
            return {
                'wch': val.toString().length * 1.5
            };
        }
    }))

    /*以第一行为初始值*/
    let result = colWidth[0];
    for (let i = 1; i < colWidth.length; i++) {
        for (let j = 0; j < colWidth[i].length; j++) {
            if (result[j]['wch'] < colWidth[i][j]['wch']) {
                result[j]['wch'] = colWidth[i][j]['wch'];
            }
        }
    }
    ws['!cols'] = result;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var dataInfo = wb.Sheets[wb.SheetNames[0]];
    const borderAll = {  //单元格外侧框线
        top: {
            style: 'thin'
        },
        bottom: {
            style: 'thin'
        },
        left: {
            style: 'thin'
        },
        right: {
            style: 'thin'
        }
    };
    const headerStyle = {
        font: {
            name: '宋体',
            sz: 12,
            color: {rgb: "000000"},
            bold: true,
            italic: false,
            underline: false
        },
        alignment: {
            horizontal: "center",
            vertical: "center"
        },
    }
    //给所有单元格加上边框
    for (var i in dataInfo) {
        if (i == '!ref' || i == '!merges' || i == '!cols') {

        } else {
            if (/^([A-Z]+)1$/.test(i)) {
                dataInfo[i + ''].s = {
                    border: borderAll,
                    font: headerStyle.font,
                    alignment: headerStyle.alignment
                }
            } else {
                dataInfo[i + ''].s = {
                    border: borderAll
                }
            }
        }
    }

    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
    var title = defaultTitle || '列表'
    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xlsx")
}

// xlsx-style 插件样式官网 https://www.npmjs.com/package/xlsx-style
export function export_json_to_excel({
        title,
        title2,
        title3,
        multiHeader = [],
        header,
        data,
        filename,
        merges = [],
        autoWidth = true,
        width,
        bookType = 'xlsx',
        myRowFont = ['1']
    } = {}) {

    /* original data */
    filename = filename || 'excel-list'
    data = [...data]
    //设置表头和标题
    data.unshift(header);
    data.unshift(title3);
    data.unshift(title2);
    data.unshift(title);
    for (let i = multiHeader.length - 1; i > -1; i--) {
        data.unshift(multiHeader[i])
    }

    var ws_name = filename;
    var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

    //  合并单元格
    if (merges.length > 0) {
        if (!ws['!merges']) ws['!merges'] = [];
        merges.forEach(item => {
        ws['!merges'].push(XLSX.utils.decode_range(item))
        })
    }

    //是否自动设置宽度
    if (autoWidth) {
        /*设置worksheet每列的最大宽度*/
        const colWidth = data.map(row => row.map(val => {
        /*先判断是否为null/undefined*/
        if (val == null) {
            return {
            'wch': 30
            };
        }
        /*再判断是否为中文*/
        else if (val.toString().charCodeAt(0) > 255) {
            return {
            'wch': val.toString().length * 2.5
            };
        } else {
            return {
            'wch': val.toString().length * 2.5
            };
        }
        }))
        /*以第一行为初始值*/
        let result = colWidth[0];
        for (let i = 1; i < colWidth.length; i++) {
        for (let j = 0; j < colWidth[i].length; j++) {
            if (result[j]['wch'] < colWidth[i][j]['wch']) {
            result[j]['wch'] = colWidth[i][j]['wch'];
            }
        }
        }
        ws['!cols'] = result;
    }else {
        /*设置worksheet每列的最大宽度*/
        const colWidth = data.map(row => row.map(val => {
        /*先判断是否为null/undefined*/
        if (val == null) {
            return {
            'wch': width
            };
        }
        /*再判断是否为中文*/
        else if (val.toString().charCodeAt(0) > 255) {
            return {
            'wch': width
            };
        } else {
            return {
            'wch': width
            };
        }
        }))
        /*以第一行为初始值*/
        let result = colWidth[0];
        for (let i = 1; i < colWidth.length; i++) {
        for (let j = 0; j < colWidth[i].length; j++) {
            if (result[j]['wch'] < colWidth[i][j]['wch']) {
            result[j]['wch'] = colWidth[i][j]['wch'];
            }
        }
        }
        ws['!cols'] = result;
    }

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var dataInfo = wb.Sheets[wb.SheetNames[0]];

    const borderAll = {  //单元格外侧框线
        top: {
            style: 'thin'
        },
        bottom: {
            style: 'thin'
        },
        left: {
            style: 'thin'
        },
        right: {
            style: 'thin'
        }
    };
    //给所有单元格加上边框
    for (var i in dataInfo) {
        if (i === '!ref' || i === '!cols' ) {

        } else {
            dataInfo[i + ''].s = {
                border: borderAll,
                alignment: {
                    horizontal: "center",
                    vertical: "center"
                },
            }
        }
    }

    // 去掉标题边框
    let arr = ["A1", "B1", "C1", "D1", "E1", "F1", "G1", "H1", "I1", "J1", "K1", "L1", "M1", "N1", "O1", "P1", "Q1", "R1", "S1", "T1", "U1", "V1", "W1", "X1", "Y1", "Z1"];
    arr.some(v => {
      //console.log(v)
      let a = merges[0].split(':')
      //console.log(a)
      if (v == a[1]) {
        //console.log(dataInfo[v])
        dataInfo[v].s = {}
        return true;
      } else {
        //console.log(dataInfo[v])
        dataInfo[v]
        dataInfo[v].s = {}
      }
    })

    // 设置主标题样式
    dataInfo["A1"].s = {
      font: {
        name: '宋体',
        sz: 26,
        //color: {rgb: "ff0000"},
        bold: true,
        italic: false,
        underline: false
      },
      alignment: {
        horizontal: "center",
        vertical: "center"
      },
      fill: {
        //单元格背景色
        //fgColor: {rgb: "008000"},
      },
    };


    // 项目导出 微调
    dataInfo["!cols"][0]['wch'] = 3.8  // 序号列宽
    dataInfo["!cols"][2]['wch'] = 31   // 建设单位列宽
    dataInfo["!cols"][3]['wch'] = 18   // 项目名称列宽
    dataInfo["!cols"][5]['wch'] = 20   // 项目状态列宽
    dataInfo["!cols"][6]['wch'] = 40   // 主要建设内容列宽
    dataInfo["!cols"][11]['wch'] = 21   // 开工时间列宽
    dataInfo["!cols"][12]['wch'] = 21   // 竣工时间列宽
    // 设置主体内容的字体
    for (var b in dataInfo) {
        var num1 = b.replace(/[^\d]/g,'');
        if (num1 > 4) {
            dataInfo[b].s = {
                font: {
                    name: '仿宋',
                    sz: 14,
                    bold: false,
                    italic: false,
                    underline: false
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center"
                },
            }
        }
    }


    // 设置
    // var aaa = ["A2","B2","C2","D2","E2","F2","G2","H2","I2","J2","K2","L2"]
    // aaa.forEach(element => {
    //     dataInfo[element].s = {
    //         // font: {
    //         // },
    //         // alignment: {
    //         //     // horizontal: "center",
    //         //     // vertical: "center"
    //         // },
    //         // fill: {
    //         //     //单元格背景色
    //         //     //fgColor: {rgb: "008000"},
    //         // },
    //         // border: {
    //         //     top: {
    //         //         style: ''
    //         //     },
    //         //     bottom: {
    //         //         style: 'thin'
    //         //     },
    //         //     left: {
    //         //         style: ''
    //         //     },
    //         //     right: {
    //         //         style: ''
    //         //     }
    //         // }
    //     };
    // });

    // 这是表头行的样式
    // var tableTitleFont = {
    //     font: {
    //         name: '宋体',
    //         sz: 26,
    //         //color: {rgb: "ff0000"},
    //         bold: true,
    //         italic: false,
    //         underline: false
    //     },
    //     alignment: {
    //         horizontal: "center",
    //         vertical: "center"
    //     },
    //     fill: {
    //         //单元格背景色
    //         //fgColor: {rgb: "008000"},
    //     },
    //     border:borderAll
    // };

    // for(var q in myRowFont){
    //     for (var b in dataInfo) {
    //         if (b.indexOf(myRowFont[q]) > -1) {
    //         dataInfo[b].s = tableTitleFont
    //         }
    //     }
    // }


    var wbout = XLSX.write(wb, {
        bookType: bookType,
        bookSST: false,
        type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
    }), `${filename}.${bookType}`);
}
